import React, { useEffect } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { chatStore, anketsStore } from 'stores';
import { Chat as ChatIcon } from '@material-ui/icons';
import { Badge } from '@material-ui/core';

const ChatIconWithBadge = observer(() => {
  const { fetchState, messages } = chatStore;
  const countMessages = messages.length;

  useEffect(
    () =>
      autorun(() => {
        chatStore.getMessages(anketsStore.anketId);
      }),
    [],
  );

  if (fetchState === 'fulfilled')
    return (
      <Badge badgeContent={countMessages} color="error">
        <ChatIcon />
      </Badge>
    );
  return <ChatIcon />;
});

export default ChatIconWithBadge;
